import { TRootState } from "../@types";

export const selectModalBrands = ( state: TRootState ) =>state.brands.brandsModalIsOpen

export const selectIsUpdateBrand = ( state: TRootState ) =>state.brands.isUpdateBrand

export const selectBrandForUpdate = ( state: TRootState ) =>state.brands.brandsForUpdate

export const selectBrandsRefreshTable =  ( state: TRootState ) =>state.brands.refreshTableBrands